export default function urlToId(url) {
  if (!url || typeof url !== "string") return undefined;
  // Prefer parsing pathname to avoid matching digits in scheme/host/port (e.g. http://0.0.0.0:8000)
  try {
    const parsed = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://demo-destek-api.inohom.cloud");
    const parts = parsed.pathname.split("/").filter(Boolean);
    const last = parts[parts.length - 1];
    const idNum = Number(last);
    if (Number.isFinite(idNum)) return String(idNum);
  } catch (_) {
    // Fallback to regex: take the LAST numeric segment in the string
    const matches = url.match(/\/(\d+)\/?/g);
    if (matches && matches.length) {
      const lastMatch = matches[matches.length - 1];
      const id = lastMatch.replace(/\D/g, "");
      if (id) return id;
    }
  }
  return undefined;
}

